import { createReducer } from '@reduxjs/toolkit';

import * as SenderActions from './actions';
import { Constants } from './constants';
import { ISenderState } from './interfaces';

const initialSenderState: ISenderState = {
    senderLogos: [],
    senderInfoList: [],
    senderOrganizationList: [],
    selectedSender: null,
    isSenderClicked: false,
};

export const senderReducer = createReducer(initialSenderState, {
    [Constants.ADD_SENDER_LOGO]: (draftState, action: ReturnType<typeof SenderActions.addSenderLogo>) => {
        const { senderLogo } = action.payload;
        if (draftState.senderLogos.some((logo) => logo.organisationId === senderLogo.organisationId)) {
            return;
        }

        draftState.senderLogos = [...draftState.senderLogos, senderLogo];
    },

    [Constants.ADD_SENDERINFO_LIST]: (draftState, action: ReturnType<typeof SenderActions.addSenderInfoList>) => {
        draftState.senderInfoList = action.payload.senderInfoList;
    },

    [Constants.ADD_SENDER_ORGANIZATION_LIST]: (
        draftState,
        action: ReturnType<typeof SenderActions.addSenderOrganisationInfo>
    ) => {
        draftState.senderOrganizationList = action.payload.senderOrganizationList;
    },

    [Constants.ADD_SELECTED_SENDER]: (draftState, action: ReturnType<typeof SenderActions.setSelectedSenderName>) => {
        draftState.selectedSender = action.payload.SelectedSender;
        draftState.isSenderClicked = action.payload.isSenderClicked;
    },
});
